// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'e-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss'],
})
export class PopupComponent {
  @Input() isActive = false;
  @Input() showCloseXButton = true;
  @Input() fullWidth = false;
  @Output() isActiveChange: EventEmitter<boolean> = new EventEmitter();

  changeIsActive() {
    this.isActiveChange.emit(!this.isActive);
  }
}
